"use strict";
// meta types
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebinarInteractionTypes = void 0;
exports.WebinarInteractionTypes = {
    view: {
        name: 'view',
        description: 'The user has observed the webinar video playing. Track this exactly once when someone lands in the webinar room while the webinar is playing.',
    },
    content_seen: {
        name: 'content_seen',
        description: 'The user has seen a particular breakpoint in the webinar. It should be paired with a `breakpointSeen` argument on the event.',
    },
    left: {
        name: 'left',
        description: 'The user navigated away from the page. We throw this in a beforeunload to try and catch all events, but is not guaranteed.',
    },
    comment: {
        name: 'comment',
        description: 'The user commented on the webinar',
    },
    viewed_message: {
        name: 'viewed_message',
        description: 'The user viewed a message sent by a moderator',
    },
    reacted_to_message: {
        name: 'reacted_to_message',
        description: 'The user reacted with an emoji to a message',
    },
    still_watching: {
        name: 'still_watching',
        description: 'The user is still watching the webinar - sent automatically on a cadence',
    },
    joined: {
        name: 'joined',
        description: 'The user loaded the webinar page',
    },
    clicked_webinar_offer: {
        name: 'clicked_webinar_offer',
        description: 'User manually clicked the webinar offer during a webinar.',
    },
    redirected_to_webinar_offer: {
        name: 'redirected_to_webinar_offer',
        description: 'User was automatically redirected to the webinar offer at the end of a webinar.',
    },
};
